import React from 'react'
import { DateWithUTCTooltip } from '../common'
import { authenticatedFetchData, API_HOST, BROWSER_TIMEZONE } from '../../lib'
import { logError } from '@tomra/datadog-browser-logging'
import { ConsumerSessionsTable } from '../common/ConsumerSessionsTable'
import { Card } from '@tomra/design-system-react/card'
import { useLoaderData, useParams } from 'react-router-dom'
import type { LoaderFunction } from 'react-router-dom'

export const bagtagLoader: LoaderFunction = async ({ params }) => {
  try {
    const tag = params.bagtag
    const bagInfo = await authenticatedFetchData(API_HOST + '/mytomra/v1.0/hotlinetool/bagsearch/' + tag).run()
    return { bagInfo }
  } catch (error: any) {
    logError(new Error('Failed to fetch bag info'), error)
    return { error }
  }
}

export const BagPage = () => {
  const params = useParams()
  const { bagInfo, error } = useLoaderData() as { bagInfo?: BagInfoType; error?: any }
  if (error || !bagInfo) {
    return (
      <div>
        <h1 className="sr-only">Bag info</h1>
        <div className="rounded-lg border-l-[3px] border-rose-500 bg-white p-4 text-left shadow-md dark:bg-gray-900 centerAbsolute">
          Whoopsie! Failed to find bag info. Please try again.
        </div>
      </div>
    )
  }

  const { scannedBag, consumerSessions } = bagInfo
  const { bagtag = params.bagtag, userId, created, charityId } = scannedBag || {}

  return (
    <div className="p-6">
      <h1 className="text-xl mb-4">Bag info</h1>

      <div className="flex space-x-4">
        <div className="w-1/4">
          <Card.Root>
            <Card.Content>
              <dl className="mb-4">
                <dt id="bagtag" className="text-gray-600 mb-2">
                  Bagtag
                </dt>
                <dd aria-labelledby="bagtag">{bagtag}</dd>
              </dl>
              <dl className="mb-4">
                <dt id="date" className="text-gray-600 mb-2">
                  Date ({BROWSER_TIMEZONE})
                </dt>
                <dd aria-labelledby="date">
                  {created ? <DateWithUTCTooltip date={created} /> : 'No information/not claimed'}
                </dd>
              </dl>
              {charityId ? (
                <dl>
                  <dt id="charityId" className="text-gray-600 mb-2">
                    Charity ID
                  </dt>
                  <dd aria-labelledby="charityId">{charityId}</dd>
                </dl>
              ) : (
                <dl>
                  <dt id="userId" className="text-gray-600 mb-2">
                    User ID
                  </dt>
                  <dd aria-labelledby="userId">{userId ? userId : 'No information/not claimed'}</dd>
                </dl>
              )}
            </Card.Content>
          </Card.Root>
        </div>

        <div className="w-3/4">
          <Card.Root>
            <Card.Header>
              <h2 className="text-lg font-medium">Consumer sessions</h2>
            </Card.Header>

            <ConsumerSessionsTable consumerSessions={consumerSessions} />
          </Card.Root>
        </div>
      </div>
    </div>
  )
}
